// Grouped client for Salesforce operations
import { ApiConfiguration } from '../ApiConfiguration';
import { Form } from '../models/Form';
import { DataFormActionRequest } from '../models/DataFormActionRequest';
import { DataFormActionResponse } from '../models/DataFormActionResponse';
import { Customer } from '../models/Customer';
import { UpdateCustomerRequest } from '../models/UpdateCustomerRequest';
import { FilterCustomerRequest } from '../models/FilterCustomerRequest';
import { DataviewCustomerResponse } from '../models/DataviewCustomerResponse';
import { ExternalLink } from '../models/ExternalLink';
import { UpdateExternalLinkRequest } from '../models/UpdateExternalLinkRequest';
import { FilterExternalLinkRequest } from '../models/FilterExternalLinkRequest';
import { DataviewExternalLinkResponse } from '../models/DataviewExternalLinkResponse';
import { MaterialAssignment } from '../models/MaterialAssignment';
import { FilterMaterialAssignmentRequest } from '../models/FilterMaterialAssignmentRequest';
import { DataviewMaterialAssignmentResponse } from '../models/DataviewMaterialAssignmentResponse';
import { ProposalLine } from '../models/ProposalLine';
import { FilterProposalLineRequest } from '../models/FilterProposalLineRequest';
import { DataviewProposalLineResponse } from '../models/DataviewProposalLineResponse';
import { StartProposalShareInstallationPlanRequest } from '../models/StartProposalShareInstallationPlanRequest';
import { StartProposalGenerateAiContentRequest } from '../models/StartProposalGenerateAiContentRequest';
import { Proposal } from '../models/Proposal';
import { FilterProposalRequest } from '../models/FilterProposalRequest';
import { DataviewProposalResponse } from '../models/DataviewProposalResponse';
import { Room } from '../models/Room';
import { FilterRoomRequest } from '../models/FilterRoomRequest';
import { DataviewRoomResponse } from '../models/DataviewRoomResponse';
import { SectionLine } from '../models/SectionLine';
import { UpdateSectionLineRequest } from '../models/UpdateSectionLineRequest';
import { FilterSectionLineRequest } from '../models/FilterSectionLineRequest';
import { DataviewSectionLineResponse } from '../models/DataviewSectionLineResponse';
import { Section } from '../models/Section';
import { UpdateSectionRequest } from '../models/UpdateSectionRequest';
import { FilterSectionRequest } from '../models/FilterSectionRequest';
import { DataviewSectionResponse } from '../models/DataviewSectionResponse';
import { Lead2 } from '../models/Lead2';
import { UpdateLead2Request } from '../models/UpdateLead2Request';
import { FilterLead2Request } from '../models/FilterLead2Request';
import { DataviewLead2Response } from '../models/DataviewLead2Response';
import { ProductItem } from '../models/ProductItem';
import { FilterProductItemRequest } from '../models/FilterProductItemRequest';
import { DataviewProductItemResponse } from '../models/DataviewProductItemResponse';
import { StartProjectScheduleAppointmentRequest } from '../models/StartProjectScheduleAppointmentRequest';
import { StartProjectAddNoteRequest } from '../models/StartProjectAddNoteRequest';
import { StartProjectAddTaskRequest } from '../models/StartProjectAddTaskRequest';
import { StartProjectGenerateContentRequest } from '../models/StartProjectGenerateContentRequest';
import { StartProjectAddFpRoomRequest } from '../models/StartProjectAddFpRoomRequest';
import { StartProjectAssignContactRequest } from '../models/StartProjectAssignContactRequest';
import { Project } from '../models/Project';
import { UpdateProjectRequest } from '../models/UpdateProjectRequest';
import { FilterProjectRequest } from '../models/FilterProjectRequest';
import { DataviewProjectResponse } from '../models/DataviewProjectResponse';
import { FormSerializer } from '../serializers/FormSerializer';
import { DataFormActionRequestSerializer } from '../serializers/DataFormActionRequestSerializer';
import { DataFormActionResponseSerializer } from '../serializers/DataFormActionResponseSerializer';
import { CustomerSerializer } from '../serializers/CustomerSerializer';
import { UpdateCustomerRequestSerializer } from '../serializers/UpdateCustomerRequestSerializer';
import { FilterCustomerRequestSerializer } from '../serializers/FilterCustomerRequestSerializer';
import { DataviewCustomerResponseSerializer } from '../serializers/DataviewCustomerResponseSerializer';
import { ExternalLinkSerializer } from '../serializers/ExternalLinkSerializer';
import { UpdateExternalLinkRequestSerializer } from '../serializers/UpdateExternalLinkRequestSerializer';
import { FilterExternalLinkRequestSerializer } from '../serializers/FilterExternalLinkRequestSerializer';
import { DataviewExternalLinkResponseSerializer } from '../serializers/DataviewExternalLinkResponseSerializer';
import { MaterialAssignmentSerializer } from '../serializers/MaterialAssignmentSerializer';
import { FilterMaterialAssignmentRequestSerializer } from '../serializers/FilterMaterialAssignmentRequestSerializer';
import { DataviewMaterialAssignmentResponseSerializer } from '../serializers/DataviewMaterialAssignmentResponseSerializer';
import { ProposalLineSerializer } from '../serializers/ProposalLineSerializer';
import { FilterProposalLineRequestSerializer } from '../serializers/FilterProposalLineRequestSerializer';
import { DataviewProposalLineResponseSerializer } from '../serializers/DataviewProposalLineResponseSerializer';
import { StartProposalShareInstallationPlanRequestSerializer } from '../serializers/StartProposalShareInstallationPlanRequestSerializer';
import { StartProposalGenerateAiContentRequestSerializer } from '../serializers/StartProposalGenerateAiContentRequestSerializer';
import { ProposalSerializer } from '../serializers/ProposalSerializer';
import { FilterProposalRequestSerializer } from '../serializers/FilterProposalRequestSerializer';
import { DataviewProposalResponseSerializer } from '../serializers/DataviewProposalResponseSerializer';
import { RoomSerializer } from '../serializers/RoomSerializer';
import { FilterRoomRequestSerializer } from '../serializers/FilterRoomRequestSerializer';
import { DataviewRoomResponseSerializer } from '../serializers/DataviewRoomResponseSerializer';
import { SectionLineSerializer } from '../serializers/SectionLineSerializer';
import { UpdateSectionLineRequestSerializer } from '../serializers/UpdateSectionLineRequestSerializer';
import { FilterSectionLineRequestSerializer } from '../serializers/FilterSectionLineRequestSerializer';
import { DataviewSectionLineResponseSerializer } from '../serializers/DataviewSectionLineResponseSerializer';
import { SectionSerializer } from '../serializers/SectionSerializer';
import { UpdateSectionRequestSerializer } from '../serializers/UpdateSectionRequestSerializer';
import { FilterSectionRequestSerializer } from '../serializers/FilterSectionRequestSerializer';
import { DataviewSectionResponseSerializer } from '../serializers/DataviewSectionResponseSerializer';
import { Lead2Serializer } from '../serializers/Lead2Serializer';
import { UpdateLead2RequestSerializer } from '../serializers/UpdateLead2RequestSerializer';
import { FilterLead2RequestSerializer } from '../serializers/FilterLead2RequestSerializer';
import { DataviewLead2ResponseSerializer } from '../serializers/DataviewLead2ResponseSerializer';
import { ProductItemSerializer } from '../serializers/ProductItemSerializer';
import { FilterProductItemRequestSerializer } from '../serializers/FilterProductItemRequestSerializer';
import { DataviewProductItemResponseSerializer } from '../serializers/DataviewProductItemResponseSerializer';
import { StartProjectScheduleAppointmentRequestSerializer } from '../serializers/StartProjectScheduleAppointmentRequestSerializer';
import { StartProjectAddNoteRequestSerializer } from '../serializers/StartProjectAddNoteRequestSerializer';
import { StartProjectAddTaskRequestSerializer } from '../serializers/StartProjectAddTaskRequestSerializer';
import { StartProjectGenerateContentRequestSerializer } from '../serializers/StartProjectGenerateContentRequestSerializer';
import { StartProjectAddFpRoomRequestSerializer } from '../serializers/StartProjectAddFpRoomRequestSerializer';
import { StartProjectAssignContactRequestSerializer } from '../serializers/StartProjectAssignContactRequestSerializer';
import { ProjectSerializer } from '../serializers/ProjectSerializer';
import { UpdateProjectRequestSerializer } from '../serializers/UpdateProjectRequestSerializer';
import { FilterProjectRequestSerializer } from '../serializers/FilterProjectRequestSerializer';
import { DataviewProjectResponseSerializer } from '../serializers/DataviewProjectResponseSerializer';

/**
 * HTTP client for Salesforce operations
 *
 * Client for Salesforce operations
 */
export class SalesforceClient {
  private readonly config: ApiConfiguration;

  constructor(config: ApiConfiguration) {
    this.config = config;
  }

  async getFormForObjectFromSalesforce(objectType: string, formName: string, objectId: string, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/salesforce/api/Object/{objectType}({objectId})/{formName}/DataForm'
      .replace('{objectType}', encodeURIComponent(String(objectType)))
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async executeActionInObjectFormFromSalesforce(objectType: string, formName: string, objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/salesforce/api/Object/{objectType}({objectId})/{formName}/DataForm'
      .replace('{objectType}', encodeURIComponent(String(objectType)))
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForObjectTypeFromSalesforce(objectType: string, formName: string, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/salesforce/api/Object/{objectType}/{formName}/DataForm'
      .replace('{objectType}', encodeURIComponent(String(objectType)))
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async executeActionInObjectTypeFormFromSalesforce(objectType: string, formName: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/salesforce/api/Object/{objectType}/{formName}/DataForm'
      .replace('{objectType}', encodeURIComponent(String(objectType)))
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForCustomer(formName: string, objectId: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, entityId?: string | null, name?: string | null, description?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesName?: string | null, propertiesBillingStreet?: string | null, propertiesBillingCity?: string | null, propertiesBillingState?: string | null, propertiesBillingPostalCode?: string | null, propertiesBillingCountry?: string | null, propertiesPhone?: string | null, propertiesFax?: string | null, propertiesAccountNumber?: string | null, propertiesDescription?: string | null, propertiesLastModifiedDate?: string | null, propertiesAccountSource?: string | null, propertiesEmail2C?: string | null, propertiesEmail3C?: string | null, propertiesMainEmailC?: string | null, propertiesPhone2C?: string | null, propertiesPhone3C?: string | null, propertiesAddressDescriptionC?: string | null, propertiesCallInstructionsC?: string | null, propertiesEMailInstructionsC?: string | null, propertiesNotesC?: string | null, propertiesPreferredMethodOfContactC?: string | null, propertiesAdditionalPhone2C?: string | null, propertiesLeadC?: string | null, propertiesProjectNotesC?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.Account({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesName !== undefined) {
      queryParams.append('Properties|Name', String(propertiesName));
    }
    if (propertiesBillingStreet !== undefined) {
      queryParams.append('Properties|BillingStreet', String(propertiesBillingStreet));
    }
    if (propertiesBillingCity !== undefined) {
      queryParams.append('Properties|BillingCity', String(propertiesBillingCity));
    }
    if (propertiesBillingState !== undefined) {
      queryParams.append('Properties|BillingState', String(propertiesBillingState));
    }
    if (propertiesBillingPostalCode !== undefined) {
      queryParams.append('Properties|BillingPostalCode', String(propertiesBillingPostalCode));
    }
    if (propertiesBillingCountry !== undefined) {
      queryParams.append('Properties|BillingCountry', String(propertiesBillingCountry));
    }
    if (propertiesPhone !== undefined) {
      queryParams.append('Properties|Phone', String(propertiesPhone));
    }
    if (propertiesFax !== undefined) {
      queryParams.append('Properties|Fax', String(propertiesFax));
    }
    if (propertiesAccountNumber !== undefined) {
      queryParams.append('Properties|AccountNumber', String(propertiesAccountNumber));
    }
    if (propertiesDescription !== undefined) {
      queryParams.append('Properties|Description', String(propertiesDescription));
    }
    if (propertiesLastModifiedDate !== undefined) {
      queryParams.append('Properties|LastModifiedDate', String(propertiesLastModifiedDate));
    }
    if (propertiesAccountSource !== undefined) {
      queryParams.append('Properties|AccountSource', String(propertiesAccountSource));
    }
    if (propertiesEmail2C !== undefined) {
      queryParams.append('Properties|Email2__c', String(propertiesEmail2C));
    }
    if (propertiesEmail3C !== undefined) {
      queryParams.append('Properties|Email3__c', String(propertiesEmail3C));
    }
    if (propertiesMainEmailC !== undefined) {
      queryParams.append('Properties|Main_Email__c', String(propertiesMainEmailC));
    }
    if (propertiesPhone2C !== undefined) {
      queryParams.append('Properties|Phone2__c', String(propertiesPhone2C));
    }
    if (propertiesPhone3C !== undefined) {
      queryParams.append('Properties|Phone3__c', String(propertiesPhone3C));
    }
    if (propertiesAddressDescriptionC !== undefined) {
      queryParams.append('Properties|Address_description__c', String(propertiesAddressDescriptionC));
    }
    if (propertiesCallInstructionsC !== undefined) {
      queryParams.append('Properties|Call_Instructions__c', String(propertiesCallInstructionsC));
    }
    if (propertiesEMailInstructionsC !== undefined) {
      queryParams.append('Properties|E_mail_Instructions__c', String(propertiesEMailInstructionsC));
    }
    if (propertiesNotesC !== undefined) {
      queryParams.append('Properties|Notes__c', String(propertiesNotesC));
    }
    if (propertiesPreferredMethodOfContactC !== undefined) {
      queryParams.append('Properties|Preferred_method_of_contact__c', String(propertiesPreferredMethodOfContactC));
    }
    if (propertiesAdditionalPhone2C !== undefined) {
      queryParams.append('Properties|Additional_Phone2__c', String(propertiesAdditionalPhone2C));
    }
    if (propertiesLeadC !== undefined) {
      queryParams.append('Properties|Lead__c', String(propertiesLeadC));
    }
    if (propertiesProjectNotesC !== undefined) {
      queryParams.append('Properties|Project_Notes__c', String(propertiesProjectNotesC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeCustomer(formName: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, entityId?: string | null, name?: string | null, description?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesName?: string | null, propertiesBillingStreet?: string | null, propertiesBillingCity?: string | null, propertiesBillingState?: string | null, propertiesBillingPostalCode?: string | null, propertiesBillingCountry?: string | null, propertiesPhone?: string | null, propertiesFax?: string | null, propertiesAccountNumber?: string | null, propertiesDescription?: string | null, propertiesLastModifiedDate?: string | null, propertiesAccountSource?: string | null, propertiesEmail2C?: string | null, propertiesEmail3C?: string | null, propertiesMainEmailC?: string | null, propertiesPhone2C?: string | null, propertiesPhone3C?: string | null, propertiesAddressDescriptionC?: string | null, propertiesCallInstructionsC?: string | null, propertiesEMailInstructionsC?: string | null, propertiesNotesC?: string | null, propertiesPreferredMethodOfContactC?: string | null, propertiesAdditionalPhone2C?: string | null, propertiesLeadC?: string | null, propertiesProjectNotesC?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.Account/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesName !== undefined) {
      queryParams.append('Properties|Name', String(propertiesName));
    }
    if (propertiesBillingStreet !== undefined) {
      queryParams.append('Properties|BillingStreet', String(propertiesBillingStreet));
    }
    if (propertiesBillingCity !== undefined) {
      queryParams.append('Properties|BillingCity', String(propertiesBillingCity));
    }
    if (propertiesBillingState !== undefined) {
      queryParams.append('Properties|BillingState', String(propertiesBillingState));
    }
    if (propertiesBillingPostalCode !== undefined) {
      queryParams.append('Properties|BillingPostalCode', String(propertiesBillingPostalCode));
    }
    if (propertiesBillingCountry !== undefined) {
      queryParams.append('Properties|BillingCountry', String(propertiesBillingCountry));
    }
    if (propertiesPhone !== undefined) {
      queryParams.append('Properties|Phone', String(propertiesPhone));
    }
    if (propertiesFax !== undefined) {
      queryParams.append('Properties|Fax', String(propertiesFax));
    }
    if (propertiesAccountNumber !== undefined) {
      queryParams.append('Properties|AccountNumber', String(propertiesAccountNumber));
    }
    if (propertiesDescription !== undefined) {
      queryParams.append('Properties|Description', String(propertiesDescription));
    }
    if (propertiesLastModifiedDate !== undefined) {
      queryParams.append('Properties|LastModifiedDate', String(propertiesLastModifiedDate));
    }
    if (propertiesAccountSource !== undefined) {
      queryParams.append('Properties|AccountSource', String(propertiesAccountSource));
    }
    if (propertiesEmail2C !== undefined) {
      queryParams.append('Properties|Email2__c', String(propertiesEmail2C));
    }
    if (propertiesEmail3C !== undefined) {
      queryParams.append('Properties|Email3__c', String(propertiesEmail3C));
    }
    if (propertiesMainEmailC !== undefined) {
      queryParams.append('Properties|Main_Email__c', String(propertiesMainEmailC));
    }
    if (propertiesPhone2C !== undefined) {
      queryParams.append('Properties|Phone2__c', String(propertiesPhone2C));
    }
    if (propertiesPhone3C !== undefined) {
      queryParams.append('Properties|Phone3__c', String(propertiesPhone3C));
    }
    if (propertiesAddressDescriptionC !== undefined) {
      queryParams.append('Properties|Address_description__c', String(propertiesAddressDescriptionC));
    }
    if (propertiesCallInstructionsC !== undefined) {
      queryParams.append('Properties|Call_Instructions__c', String(propertiesCallInstructionsC));
    }
    if (propertiesEMailInstructionsC !== undefined) {
      queryParams.append('Properties|E_mail_Instructions__c', String(propertiesEMailInstructionsC));
    }
    if (propertiesNotesC !== undefined) {
      queryParams.append('Properties|Notes__c', String(propertiesNotesC));
    }
    if (propertiesPreferredMethodOfContactC !== undefined) {
      queryParams.append('Properties|Preferred_method_of_contact__c', String(propertiesPreferredMethodOfContactC));
    }
    if (propertiesAdditionalPhone2C !== undefined) {
      queryParams.append('Properties|Additional_Phone2__c', String(propertiesAdditionalPhone2C));
    }
    if (propertiesLeadC !== undefined) {
      queryParams.append('Properties|Lead__c', String(propertiesLeadC));
    }
    if (propertiesProjectNotesC !== undefined) {
      queryParams.append('Properties|Project_Notes__c', String(propertiesProjectNotesC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterCustomer(request?: FilterCustomerRequest | null, options?: { headers?: Record<string, string> }): Promise<Customer[]> {
    const path = '/app/api/Object/salesforce.Account/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCustomerRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => CustomerSerializer.fromObject(item));
  }

  async updateCustomer(objectId: string, request?: UpdateCustomerRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.Account({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateCustomerRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentCustomer(request?: FilterCustomerRequest | null, options?: { headers?: Record<string, string> }): Promise<Customer[]> {
    const path = '/app/api/Object/salesforce.Account/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCustomerRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => CustomerSerializer.fromObject(item));
  }

  async dataViewCustomer(request?: FilterCustomerRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewCustomerResponse> {
    const path = '/app/api/Object/salesforce.Account/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCustomerRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewCustomerResponseSerializer.fromObject(data);
  }

  async getFormForExternalLink(formName: string, objectId: string, externalId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesIsDeleted?: boolean | null, propertiesName?: string | null, propertiesDescriptionC?: string | null, propertiesNameC?: string | null, propertiesParentPlanC?: string | null, propertiesParentRoomC?: string | null, propertiesRelatedObjectTypeC?: string | null, propertiesTypeC?: string | null, propertiesUrlC?: string | null, propertiesParentProjectC?: string | null, propertiesOptionNameC?: string | null, propertiesIsVideoC?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_ExternalLink__c({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesIsDeleted !== undefined) {
      queryParams.append('Properties|IsDeleted', String(propertiesIsDeleted));
    }
    if (propertiesName !== undefined) {
      queryParams.append('Properties|Name', String(propertiesName));
    }
    if (propertiesDescriptionC !== undefined) {
      queryParams.append('Properties|Description__c', String(propertiesDescriptionC));
    }
    if (propertiesNameC !== undefined) {
      queryParams.append('Properties|Name__c', String(propertiesNameC));
    }
    if (propertiesParentPlanC !== undefined) {
      queryParams.append('Properties|ParentPlan__c', String(propertiesParentPlanC));
    }
    if (propertiesParentRoomC !== undefined) {
      queryParams.append('Properties|ParentRoom__c', String(propertiesParentRoomC));
    }
    if (propertiesRelatedObjectTypeC !== undefined) {
      queryParams.append('Properties|RelatedObjectType__c', String(propertiesRelatedObjectTypeC));
    }
    if (propertiesTypeC !== undefined) {
      queryParams.append('Properties|Type__c', String(propertiesTypeC));
    }
    if (propertiesUrlC !== undefined) {
      queryParams.append('Properties|URL__c', String(propertiesUrlC));
    }
    if (propertiesParentProjectC !== undefined) {
      queryParams.append('Properties|Parent_Project__c', String(propertiesParentProjectC));
    }
    if (propertiesOptionNameC !== undefined) {
      queryParams.append('Properties|Option_Name__c', String(propertiesOptionNameC));
    }
    if (propertiesIsVideoC !== undefined) {
      queryParams.append('Properties|IsVideo__c', String(propertiesIsVideoC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeExternalLink(formName: string, externalId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesIsDeleted?: boolean | null, propertiesName?: string | null, propertiesDescriptionC?: string | null, propertiesNameC?: string | null, propertiesParentPlanC?: string | null, propertiesParentRoomC?: string | null, propertiesRelatedObjectTypeC?: string | null, propertiesTypeC?: string | null, propertiesUrlC?: string | null, propertiesParentProjectC?: string | null, propertiesOptionNameC?: string | null, propertiesIsVideoC?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_ExternalLink__c/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesIsDeleted !== undefined) {
      queryParams.append('Properties|IsDeleted', String(propertiesIsDeleted));
    }
    if (propertiesName !== undefined) {
      queryParams.append('Properties|Name', String(propertiesName));
    }
    if (propertiesDescriptionC !== undefined) {
      queryParams.append('Properties|Description__c', String(propertiesDescriptionC));
    }
    if (propertiesNameC !== undefined) {
      queryParams.append('Properties|Name__c', String(propertiesNameC));
    }
    if (propertiesParentPlanC !== undefined) {
      queryParams.append('Properties|ParentPlan__c', String(propertiesParentPlanC));
    }
    if (propertiesParentRoomC !== undefined) {
      queryParams.append('Properties|ParentRoom__c', String(propertiesParentRoomC));
    }
    if (propertiesRelatedObjectTypeC !== undefined) {
      queryParams.append('Properties|RelatedObjectType__c', String(propertiesRelatedObjectTypeC));
    }
    if (propertiesTypeC !== undefined) {
      queryParams.append('Properties|Type__c', String(propertiesTypeC));
    }
    if (propertiesUrlC !== undefined) {
      queryParams.append('Properties|URL__c', String(propertiesUrlC));
    }
    if (propertiesParentProjectC !== undefined) {
      queryParams.append('Properties|Parent_Project__c', String(propertiesParentProjectC));
    }
    if (propertiesOptionNameC !== undefined) {
      queryParams.append('Properties|Option_Name__c', String(propertiesOptionNameC));
    }
    if (propertiesIsVideoC !== undefined) {
      queryParams.append('Properties|IsVideo__c', String(propertiesIsVideoC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterExternalLink(request?: FilterExternalLinkRequest | null, options?: { headers?: Record<string, string> }): Promise<ExternalLink[]> {
    const path = '/app/api/Object/salesforce.INET_ExternalLink__c/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterExternalLinkRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ExternalLinkSerializer.fromObject(item));
  }

  async updateExternalLink(objectId: string, request?: UpdateExternalLinkRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.INET_ExternalLink__c({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateExternalLinkRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentExternalLink(request?: FilterExternalLinkRequest | null, options?: { headers?: Record<string, string> }): Promise<ExternalLink[]> {
    const path = '/app/api/Object/salesforce.INET_ExternalLink__c/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterExternalLinkRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ExternalLinkSerializer.fromObject(item));
  }

  async dataViewExternalLink(request?: FilterExternalLinkRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewExternalLinkResponse> {
    const path = '/app/api/Object/salesforce.INET_ExternalLink__c/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterExternalLinkRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewExternalLinkResponseSerializer.fromObject(data);
  }

  async getFormForMaterialAssignment(formName: string, objectId: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesIsDeleted?: boolean | null, propertiesName?: string | null, propertiesParentOptionC?: string | null, propertiesAreaC?: number | null, propertiesPerimeterC?: number | null, propertiesRoomC?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_MaterialAssignment__c({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesIsDeleted !== undefined) {
      queryParams.append('Properties|IsDeleted', String(propertiesIsDeleted));
    }
    if (propertiesName !== undefined) {
      queryParams.append('Properties|Name', String(propertiesName));
    }
    if (propertiesParentOptionC !== undefined) {
      queryParams.append('Properties|ParentOption__c', String(propertiesParentOptionC));
    }
    if (propertiesAreaC !== undefined) {
      queryParams.append('Properties|Area__c', String(propertiesAreaC));
    }
    if (propertiesPerimeterC !== undefined) {
      queryParams.append('Properties|Perimeter__c', String(propertiesPerimeterC));
    }
    if (propertiesRoomC !== undefined) {
      queryParams.append('Properties|Room__c', String(propertiesRoomC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeMaterialAssignment(formName: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesIsDeleted?: boolean | null, propertiesName?: string | null, propertiesParentOptionC?: string | null, propertiesAreaC?: number | null, propertiesPerimeterC?: number | null, propertiesRoomC?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_MaterialAssignment__c/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesIsDeleted !== undefined) {
      queryParams.append('Properties|IsDeleted', String(propertiesIsDeleted));
    }
    if (propertiesName !== undefined) {
      queryParams.append('Properties|Name', String(propertiesName));
    }
    if (propertiesParentOptionC !== undefined) {
      queryParams.append('Properties|ParentOption__c', String(propertiesParentOptionC));
    }
    if (propertiesAreaC !== undefined) {
      queryParams.append('Properties|Area__c', String(propertiesAreaC));
    }
    if (propertiesPerimeterC !== undefined) {
      queryParams.append('Properties|Perimeter__c', String(propertiesPerimeterC));
    }
    if (propertiesRoomC !== undefined) {
      queryParams.append('Properties|Room__c', String(propertiesRoomC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterMaterialAssignment(request?: FilterMaterialAssignmentRequest | null, options?: { headers?: Record<string, string> }): Promise<MaterialAssignment[]> {
    const path = '/app/api/Object/salesforce.INET_MaterialAssignment__c/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterMaterialAssignmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => MaterialAssignmentSerializer.fromObject(item));
  }

  async recentMaterialAssignment(request?: FilterMaterialAssignmentRequest | null, options?: { headers?: Record<string, string> }): Promise<MaterialAssignment[]> {
    const path = '/app/api/Object/salesforce.INET_MaterialAssignment__c/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterMaterialAssignmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => MaterialAssignmentSerializer.fromObject(item));
  }

  async dataViewMaterialAssignment(request?: FilterMaterialAssignmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewMaterialAssignmentResponse> {
    const path = '/app/api/Object/salesforce.INET_MaterialAssignment__c/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterMaterialAssignmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewMaterialAssignmentResponseSerializer.fromObject(data);
  }

  async getFormForproposalLine(formName: string, objectId: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesIsDeleted?: boolean | null, propertiesName?: string | null, propertiesOptionC?: string | null, propertiesAdjQuantityC?: number | null, propertiesDescriptionC?: string | null, propertiesMarginC?: number | null, propertiesCost1C?: number | null, propertiesRealWasteC?: number | null, propertiesTotalBeforeTaxC?: number | null, propertiesTotalCostC?: number | null, propertiesUnitPriceC?: number | null, propertiesUnitCostC?: number | null, propertiesIsDiscountItemC?: boolean | null, propertiesProductC?: string | null, propertiesCost2C?: number | null, propertiesPrice1C?: number | null, propertiesPrice2C?: number | null, propertiesIndexC?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_OptionLineItem__c({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesIsDeleted !== undefined) {
      queryParams.append('Properties|IsDeleted', String(propertiesIsDeleted));
    }
    if (propertiesName !== undefined) {
      queryParams.append('Properties|Name', String(propertiesName));
    }
    if (propertiesOptionC !== undefined) {
      queryParams.append('Properties|Option__c', String(propertiesOptionC));
    }
    if (propertiesAdjQuantityC !== undefined) {
      queryParams.append('Properties|AdjQuantity__c', String(propertiesAdjQuantityC));
    }
    if (propertiesDescriptionC !== undefined) {
      queryParams.append('Properties|Description__c', String(propertiesDescriptionC));
    }
    if (propertiesMarginC !== undefined) {
      queryParams.append('Properties|Margin__c', String(propertiesMarginC));
    }
    if (propertiesCost1C !== undefined) {
      queryParams.append('Properties|Cost1__c', String(propertiesCost1C));
    }
    if (propertiesRealWasteC !== undefined) {
      queryParams.append('Properties|RealWaste__c', String(propertiesRealWasteC));
    }
    if (propertiesTotalBeforeTaxC !== undefined) {
      queryParams.append('Properties|TotalBeforeTax__c', String(propertiesTotalBeforeTaxC));
    }
    if (propertiesTotalCostC !== undefined) {
      queryParams.append('Properties|TotalCost__c', String(propertiesTotalCostC));
    }
    if (propertiesUnitPriceC !== undefined) {
      queryParams.append('Properties|UnitPrice__c', String(propertiesUnitPriceC));
    }
    if (propertiesUnitCostC !== undefined) {
      queryParams.append('Properties|UnitCost__c', String(propertiesUnitCostC));
    }
    if (propertiesIsDiscountItemC !== undefined) {
      queryParams.append('Properties|IsDiscountItem__c', String(propertiesIsDiscountItemC));
    }
    if (propertiesProductC !== undefined) {
      queryParams.append('Properties|Product__c', String(propertiesProductC));
    }
    if (propertiesCost2C !== undefined) {
      queryParams.append('Properties|Cost2__c', String(propertiesCost2C));
    }
    if (propertiesPrice1C !== undefined) {
      queryParams.append('Properties|Price1__c', String(propertiesPrice1C));
    }
    if (propertiesPrice2C !== undefined) {
      queryParams.append('Properties|Price2__c', String(propertiesPrice2C));
    }
    if (propertiesIndexC !== undefined) {
      queryParams.append('Properties|Index__c', String(propertiesIndexC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeproposalLine(formName: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesIsDeleted?: boolean | null, propertiesName?: string | null, propertiesOptionC?: string | null, propertiesAdjQuantityC?: number | null, propertiesDescriptionC?: string | null, propertiesMarginC?: number | null, propertiesCost1C?: number | null, propertiesRealWasteC?: number | null, propertiesTotalBeforeTaxC?: number | null, propertiesTotalCostC?: number | null, propertiesUnitPriceC?: number | null, propertiesUnitCostC?: number | null, propertiesIsDiscountItemC?: boolean | null, propertiesProductC?: string | null, propertiesCost2C?: number | null, propertiesPrice1C?: number | null, propertiesPrice2C?: number | null, propertiesIndexC?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_OptionLineItem__c/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesIsDeleted !== undefined) {
      queryParams.append('Properties|IsDeleted', String(propertiesIsDeleted));
    }
    if (propertiesName !== undefined) {
      queryParams.append('Properties|Name', String(propertiesName));
    }
    if (propertiesOptionC !== undefined) {
      queryParams.append('Properties|Option__c', String(propertiesOptionC));
    }
    if (propertiesAdjQuantityC !== undefined) {
      queryParams.append('Properties|AdjQuantity__c', String(propertiesAdjQuantityC));
    }
    if (propertiesDescriptionC !== undefined) {
      queryParams.append('Properties|Description__c', String(propertiesDescriptionC));
    }
    if (propertiesMarginC !== undefined) {
      queryParams.append('Properties|Margin__c', String(propertiesMarginC));
    }
    if (propertiesCost1C !== undefined) {
      queryParams.append('Properties|Cost1__c', String(propertiesCost1C));
    }
    if (propertiesRealWasteC !== undefined) {
      queryParams.append('Properties|RealWaste__c', String(propertiesRealWasteC));
    }
    if (propertiesTotalBeforeTaxC !== undefined) {
      queryParams.append('Properties|TotalBeforeTax__c', String(propertiesTotalBeforeTaxC));
    }
    if (propertiesTotalCostC !== undefined) {
      queryParams.append('Properties|TotalCost__c', String(propertiesTotalCostC));
    }
    if (propertiesUnitPriceC !== undefined) {
      queryParams.append('Properties|UnitPrice__c', String(propertiesUnitPriceC));
    }
    if (propertiesUnitCostC !== undefined) {
      queryParams.append('Properties|UnitCost__c', String(propertiesUnitCostC));
    }
    if (propertiesIsDiscountItemC !== undefined) {
      queryParams.append('Properties|IsDiscountItem__c', String(propertiesIsDiscountItemC));
    }
    if (propertiesProductC !== undefined) {
      queryParams.append('Properties|Product__c', String(propertiesProductC));
    }
    if (propertiesCost2C !== undefined) {
      queryParams.append('Properties|Cost2__c', String(propertiesCost2C));
    }
    if (propertiesPrice1C !== undefined) {
      queryParams.append('Properties|Price1__c', String(propertiesPrice1C));
    }
    if (propertiesPrice2C !== undefined) {
      queryParams.append('Properties|Price2__c', String(propertiesPrice2C));
    }
    if (propertiesIndexC !== undefined) {
      queryParams.append('Properties|Index__c', String(propertiesIndexC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterProposalLine(request?: FilterProposalLineRequest | null, options?: { headers?: Record<string, string> }): Promise<ProposalLine[]> {
    const path = '/app/api/Object/salesforce.INET_OptionLineItem__c/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProposalLineRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProposalLineSerializer.fromObject(item));
  }

  async recentProposalLine(request?: FilterProposalLineRequest | null, options?: { headers?: Record<string, string> }): Promise<ProposalLine[]> {
    const path = '/app/api/Object/salesforce.INET_OptionLineItem__c/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProposalLineRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProposalLineSerializer.fromObject(item));
  }

  async dataViewProposalLine(request?: FilterProposalLineRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewProposalLineResponse> {
    const path = '/app/api/Object/salesforce.INET_OptionLineItem__c/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProposalLineRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewProposalLineResponseSerializer.fromObject(data);
  }

  async getProposalShareInstallationPlanForm(objectId: string, fromName?: string | null, fromEmail?: string | null, ccEmail?: string | null, toName?: string | null, toEmail?: string | null, subject?: string | null, message?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_Option__c({objectId})/UserAction(e0e28b48-cfea-4acf-b745-7caf0f23a7c7)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (fromName !== undefined) {
      queryParams.append('FromName', String(fromName));
    }
    if (fromEmail !== undefined) {
      queryParams.append('FromEmail', String(fromEmail));
    }
    if (ccEmail !== undefined) {
      queryParams.append('CCEmail', String(ccEmail));
    }
    if (toName !== undefined) {
      queryParams.append('ToName', String(toName));
    }
    if (toEmail !== undefined) {
      queryParams.append('ToEmail', String(toEmail));
    }
    if (subject !== undefined) {
      queryParams.append('Subject', String(subject));
    }
    if (message !== undefined) {
      queryParams.append('Message', String(message));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runProposalShareInstallationPlanAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.INET_Option__c({objectId})/UserAction(e0e28b48-cfea-4acf-b745-7caf0f23a7c7)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProposalShareInstallationPlan(objectId: string, request?: StartProposalShareInstallationPlanRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.INET_Option__c({objectId})/UserAction(e0e28b48-cfea-4acf-b745-7caf0f23a7c7)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartProposalShareInstallationPlanRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getProposalGenerateAiContentForm(objectId: string, assistantId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_Option__c({objectId})/UserAction(47c06b11-6034-4f44-a8d2-1fd35b4369e2)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (assistantId !== undefined) {
      queryParams.append('AssistantId', String(assistantId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runProposalGenerateAiContentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.INET_Option__c({objectId})/UserAction(47c06b11-6034-4f44-a8d2-1fd35b4369e2)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProposalGenerateAiContent(objectId: string, request?: StartProposalGenerateAiContentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.INET_Option__c({objectId})/UserAction(47c06b11-6034-4f44-a8d2-1fd35b4369e2)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartProposalGenerateAiContentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async runProposalOtgInstallationPlanAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.INET_Option__c({objectId})/UserAction(5502ddad-3dd3-48c0-99f1-83fe59c9a952)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProposalOtgInstallationPlan(objectId: string, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.INET_Option__c({objectId})/UserAction(5502ddad-3dd3-48c0-99f1-83fe59c9a952)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForProposal(formName: string, objectId: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, summary?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesIsDeleted?: boolean | null, propertiesName?: string | null, propertiesCreatedDate?: string | null, propertiesParentProjectC?: string | null, propertiesTotalAfterDiscountBeforeTaxC?: number | null, propertiesTotalCostC?: number | null, propertiesTotalTaxC?: number | null, propertiesOptionNumberC?: number | null, propertiesOptionStatusC?: string | null, propertiesCustomerNameC?: string | null, propertiesLandedDateC?: string | null, propertiesProducedDateC?: string | null, propertiesNotesC?: string | null, propertiesLeadingProductsC?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_Option__c({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (summary !== undefined) {
      queryParams.append('Summary', String(summary));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesIsDeleted !== undefined) {
      queryParams.append('Properties|IsDeleted', String(propertiesIsDeleted));
    }
    if (propertiesName !== undefined) {
      queryParams.append('Properties|Name', String(propertiesName));
    }
    if (propertiesCreatedDate !== undefined) {
      queryParams.append('Properties|CreatedDate', String(propertiesCreatedDate));
    }
    if (propertiesParentProjectC !== undefined) {
      queryParams.append('Properties|ParentProject__c', String(propertiesParentProjectC));
    }
    if (propertiesTotalAfterDiscountBeforeTaxC !== undefined) {
      queryParams.append('Properties|TotalAfterDiscountBeforeTax__c', String(propertiesTotalAfterDiscountBeforeTaxC));
    }
    if (propertiesTotalCostC !== undefined) {
      queryParams.append('Properties|TotalCost__c', String(propertiesTotalCostC));
    }
    if (propertiesTotalTaxC !== undefined) {
      queryParams.append('Properties|TotalTax__c', String(propertiesTotalTaxC));
    }
    if (propertiesOptionNumberC !== undefined) {
      queryParams.append('Properties|Option_Number__c', String(propertiesOptionNumberC));
    }
    if (propertiesOptionStatusC !== undefined) {
      queryParams.append('Properties|Option_Status__c', String(propertiesOptionStatusC));
    }
    if (propertiesCustomerNameC !== undefined) {
      queryParams.append('Properties|Customer_Name__c', String(propertiesCustomerNameC));
    }
    if (propertiesLandedDateC !== undefined) {
      queryParams.append('Properties|Landed_Date__c', String(propertiesLandedDateC));
    }
    if (propertiesProducedDateC !== undefined) {
      queryParams.append('Properties|Produced_Date__c', String(propertiesProducedDateC));
    }
    if (propertiesNotesC !== undefined) {
      queryParams.append('Properties|Notes__c', String(propertiesNotesC));
    }
    if (propertiesLeadingProductsC !== undefined) {
      queryParams.append('Properties|Leading_Products__c', String(propertiesLeadingProductsC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeProposal(formName: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, summary?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesIsDeleted?: boolean | null, propertiesName?: string | null, propertiesCreatedDate?: string | null, propertiesParentProjectC?: string | null, propertiesTotalAfterDiscountBeforeTaxC?: number | null, propertiesTotalCostC?: number | null, propertiesTotalTaxC?: number | null, propertiesOptionNumberC?: number | null, propertiesOptionStatusC?: string | null, propertiesCustomerNameC?: string | null, propertiesLandedDateC?: string | null, propertiesProducedDateC?: string | null, propertiesNotesC?: string | null, propertiesLeadingProductsC?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_Option__c/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (summary !== undefined) {
      queryParams.append('Summary', String(summary));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesIsDeleted !== undefined) {
      queryParams.append('Properties|IsDeleted', String(propertiesIsDeleted));
    }
    if (propertiesName !== undefined) {
      queryParams.append('Properties|Name', String(propertiesName));
    }
    if (propertiesCreatedDate !== undefined) {
      queryParams.append('Properties|CreatedDate', String(propertiesCreatedDate));
    }
    if (propertiesParentProjectC !== undefined) {
      queryParams.append('Properties|ParentProject__c', String(propertiesParentProjectC));
    }
    if (propertiesTotalAfterDiscountBeforeTaxC !== undefined) {
      queryParams.append('Properties|TotalAfterDiscountBeforeTax__c', String(propertiesTotalAfterDiscountBeforeTaxC));
    }
    if (propertiesTotalCostC !== undefined) {
      queryParams.append('Properties|TotalCost__c', String(propertiesTotalCostC));
    }
    if (propertiesTotalTaxC !== undefined) {
      queryParams.append('Properties|TotalTax__c', String(propertiesTotalTaxC));
    }
    if (propertiesOptionNumberC !== undefined) {
      queryParams.append('Properties|Option_Number__c', String(propertiesOptionNumberC));
    }
    if (propertiesOptionStatusC !== undefined) {
      queryParams.append('Properties|Option_Status__c', String(propertiesOptionStatusC));
    }
    if (propertiesCustomerNameC !== undefined) {
      queryParams.append('Properties|Customer_Name__c', String(propertiesCustomerNameC));
    }
    if (propertiesLandedDateC !== undefined) {
      queryParams.append('Properties|Landed_Date__c', String(propertiesLandedDateC));
    }
    if (propertiesProducedDateC !== undefined) {
      queryParams.append('Properties|Produced_Date__c', String(propertiesProducedDateC));
    }
    if (propertiesNotesC !== undefined) {
      queryParams.append('Properties|Notes__c', String(propertiesNotesC));
    }
    if (propertiesLeadingProductsC !== undefined) {
      queryParams.append('Properties|Leading_Products__c', String(propertiesLeadingProductsC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getUpsertFormForTypeProposal(externalId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    const path = '/app/api/Object/salesforce.INET_Option__c/Upsert/DataForm';

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterProposal(request?: FilterProposalRequest | null, options?: { headers?: Record<string, string> }): Promise<Proposal[]> {
    const path = '/app/api/Object/salesforce.INET_Option__c/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProposalRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProposalSerializer.fromObject(item));
  }

  async recentProposal(request?: FilterProposalRequest | null, options?: { headers?: Record<string, string> }): Promise<Proposal[]> {
    const path = '/app/api/Object/salesforce.INET_Option__c/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProposalRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProposalSerializer.fromObject(item));
  }

  async dataViewProposal(request?: FilterProposalRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewProposalResponse> {
    const path = '/app/api/Object/salesforce.INET_Option__c/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProposalRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewProposalResponseSerializer.fromObject(data);
  }

  async getFormForRoom(formName: string, objectId: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesIsDeleted?: boolean | null, propertiesFloorPlanC?: string | null, propertiesAreaTakeoutC?: number | null, propertiesAreaC?: number | null, propertiesNameC?: string | null, propertiesNotesC?: string | null, propertiesPerimeterC?: number | null, propertiesRoomTypeC?: string | null, propertiesRoomImageUrlC?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_Room__c({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesIsDeleted !== undefined) {
      queryParams.append('Properties|IsDeleted', String(propertiesIsDeleted));
    }
    if (propertiesFloorPlanC !== undefined) {
      queryParams.append('Properties|FloorPlan__c', String(propertiesFloorPlanC));
    }
    if (propertiesAreaTakeoutC !== undefined) {
      queryParams.append('Properties|AreaTakeout__c', String(propertiesAreaTakeoutC));
    }
    if (propertiesAreaC !== undefined) {
      queryParams.append('Properties|Area__c', String(propertiesAreaC));
    }
    if (propertiesNameC !== undefined) {
      queryParams.append('Properties|Name__c', String(propertiesNameC));
    }
    if (propertiesNotesC !== undefined) {
      queryParams.append('Properties|Notes__c', String(propertiesNotesC));
    }
    if (propertiesPerimeterC !== undefined) {
      queryParams.append('Properties|Perimeter__c', String(propertiesPerimeterC));
    }
    if (propertiesRoomTypeC !== undefined) {
      queryParams.append('Properties|RoomType__c', String(propertiesRoomTypeC));
    }
    if (propertiesRoomImageUrlC !== undefined) {
      queryParams.append('Properties|RoomImageURL__c', String(propertiesRoomImageUrlC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeRoom(formName: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesIsDeleted?: boolean | null, propertiesFloorPlanC?: string | null, propertiesAreaTakeoutC?: number | null, propertiesAreaC?: number | null, propertiesNameC?: string | null, propertiesNotesC?: string | null, propertiesPerimeterC?: number | null, propertiesRoomTypeC?: string | null, propertiesRoomImageUrlC?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_Room__c/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesIsDeleted !== undefined) {
      queryParams.append('Properties|IsDeleted', String(propertiesIsDeleted));
    }
    if (propertiesFloorPlanC !== undefined) {
      queryParams.append('Properties|FloorPlan__c', String(propertiesFloorPlanC));
    }
    if (propertiesAreaTakeoutC !== undefined) {
      queryParams.append('Properties|AreaTakeout__c', String(propertiesAreaTakeoutC));
    }
    if (propertiesAreaC !== undefined) {
      queryParams.append('Properties|Area__c', String(propertiesAreaC));
    }
    if (propertiesNameC !== undefined) {
      queryParams.append('Properties|Name__c', String(propertiesNameC));
    }
    if (propertiesNotesC !== undefined) {
      queryParams.append('Properties|Notes__c', String(propertiesNotesC));
    }
    if (propertiesPerimeterC !== undefined) {
      queryParams.append('Properties|Perimeter__c', String(propertiesPerimeterC));
    }
    if (propertiesRoomTypeC !== undefined) {
      queryParams.append('Properties|RoomType__c', String(propertiesRoomTypeC));
    }
    if (propertiesRoomImageUrlC !== undefined) {
      queryParams.append('Properties|RoomImageURL__c', String(propertiesRoomImageUrlC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterRoom(request?: FilterRoomRequest | null, options?: { headers?: Record<string, string> }): Promise<Room[]> {
    const path = '/app/api/Object/salesforce.INET_Room__c/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterRoomRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => RoomSerializer.fromObject(item));
  }

  async recentRoom(request?: FilterRoomRequest | null, options?: { headers?: Record<string, string> }): Promise<Room[]> {
    const path = '/app/api/Object/salesforce.INET_Room__c/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterRoomRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => RoomSerializer.fromObject(item));
  }

  async dataViewRoom(request?: FilterRoomRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewRoomResponse> {
    const path = '/app/api/Object/salesforce.INET_Room__c/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterRoomRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewRoomResponseSerializer.fromObject(data);
  }

  async getFormForSectionLine(formName: string, objectId: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesIsDeleted?: boolean | null, propertiesName?: string | null, propertiesSectionC?: string | null, propertiesAdjQuantityC?: number | null, propertiesDescriptionC?: string | null, propertiesMarginC?: number | null, propertiesCost1C?: number | null, propertiesRealWasteC?: number | null, propertiesTaxFactorC?: number | null, propertiesTaxPriceC?: number | null, propertiesTotalBeforeTaxC?: number | null, propertiesTotalCostC?: number | null, propertiesUnitPriceC?: number | null, propertiesUnitCostC?: number | null, propertiesIsDiscountItemC?: boolean | null, propertiesProductC?: string | null, propertiesCost2C?: number | null, propertiesPrice1C?: number | null, propertiesPrice2C?: number | null, propertiesIndexC?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_SectionLineItem__c({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesIsDeleted !== undefined) {
      queryParams.append('Properties|IsDeleted', String(propertiesIsDeleted));
    }
    if (propertiesName !== undefined) {
      queryParams.append('Properties|Name', String(propertiesName));
    }
    if (propertiesSectionC !== undefined) {
      queryParams.append('Properties|Section__c', String(propertiesSectionC));
    }
    if (propertiesAdjQuantityC !== undefined) {
      queryParams.append('Properties|AdjQuantity__c', String(propertiesAdjQuantityC));
    }
    if (propertiesDescriptionC !== undefined) {
      queryParams.append('Properties|Description__c', String(propertiesDescriptionC));
    }
    if (propertiesMarginC !== undefined) {
      queryParams.append('Properties|Margin__c', String(propertiesMarginC));
    }
    if (propertiesCost1C !== undefined) {
      queryParams.append('Properties|Cost1__c', String(propertiesCost1C));
    }
    if (propertiesRealWasteC !== undefined) {
      queryParams.append('Properties|RealWaste__c', String(propertiesRealWasteC));
    }
    if (propertiesTaxFactorC !== undefined) {
      queryParams.append('Properties|TaxFactor__c', String(propertiesTaxFactorC));
    }
    if (propertiesTaxPriceC !== undefined) {
      queryParams.append('Properties|TaxPrice__c', String(propertiesTaxPriceC));
    }
    if (propertiesTotalBeforeTaxC !== undefined) {
      queryParams.append('Properties|TotalBeforeTax__c', String(propertiesTotalBeforeTaxC));
    }
    if (propertiesTotalCostC !== undefined) {
      queryParams.append('Properties|TotalCost__c', String(propertiesTotalCostC));
    }
    if (propertiesUnitPriceC !== undefined) {
      queryParams.append('Properties|UnitPrice__c', String(propertiesUnitPriceC));
    }
    if (propertiesUnitCostC !== undefined) {
      queryParams.append('Properties|UnitCost__c', String(propertiesUnitCostC));
    }
    if (propertiesIsDiscountItemC !== undefined) {
      queryParams.append('Properties|IsDiscountItem__c', String(propertiesIsDiscountItemC));
    }
    if (propertiesProductC !== undefined) {
      queryParams.append('Properties|Product__c', String(propertiesProductC));
    }
    if (propertiesCost2C !== undefined) {
      queryParams.append('Properties|Cost2__c', String(propertiesCost2C));
    }
    if (propertiesPrice1C !== undefined) {
      queryParams.append('Properties|Price1__c', String(propertiesPrice1C));
    }
    if (propertiesPrice2C !== undefined) {
      queryParams.append('Properties|Price2__c', String(propertiesPrice2C));
    }
    if (propertiesIndexC !== undefined) {
      queryParams.append('Properties|Index__c', String(propertiesIndexC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeSectionLine(formName: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesIsDeleted?: boolean | null, propertiesName?: string | null, propertiesSectionC?: string | null, propertiesAdjQuantityC?: number | null, propertiesDescriptionC?: string | null, propertiesMarginC?: number | null, propertiesCost1C?: number | null, propertiesRealWasteC?: number | null, propertiesTaxFactorC?: number | null, propertiesTaxPriceC?: number | null, propertiesTotalBeforeTaxC?: number | null, propertiesTotalCostC?: number | null, propertiesUnitPriceC?: number | null, propertiesUnitCostC?: number | null, propertiesIsDiscountItemC?: boolean | null, propertiesProductC?: string | null, propertiesCost2C?: number | null, propertiesPrice1C?: number | null, propertiesPrice2C?: number | null, propertiesIndexC?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_SectionLineItem__c/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesIsDeleted !== undefined) {
      queryParams.append('Properties|IsDeleted', String(propertiesIsDeleted));
    }
    if (propertiesName !== undefined) {
      queryParams.append('Properties|Name', String(propertiesName));
    }
    if (propertiesSectionC !== undefined) {
      queryParams.append('Properties|Section__c', String(propertiesSectionC));
    }
    if (propertiesAdjQuantityC !== undefined) {
      queryParams.append('Properties|AdjQuantity__c', String(propertiesAdjQuantityC));
    }
    if (propertiesDescriptionC !== undefined) {
      queryParams.append('Properties|Description__c', String(propertiesDescriptionC));
    }
    if (propertiesMarginC !== undefined) {
      queryParams.append('Properties|Margin__c', String(propertiesMarginC));
    }
    if (propertiesCost1C !== undefined) {
      queryParams.append('Properties|Cost1__c', String(propertiesCost1C));
    }
    if (propertiesRealWasteC !== undefined) {
      queryParams.append('Properties|RealWaste__c', String(propertiesRealWasteC));
    }
    if (propertiesTaxFactorC !== undefined) {
      queryParams.append('Properties|TaxFactor__c', String(propertiesTaxFactorC));
    }
    if (propertiesTaxPriceC !== undefined) {
      queryParams.append('Properties|TaxPrice__c', String(propertiesTaxPriceC));
    }
    if (propertiesTotalBeforeTaxC !== undefined) {
      queryParams.append('Properties|TotalBeforeTax__c', String(propertiesTotalBeforeTaxC));
    }
    if (propertiesTotalCostC !== undefined) {
      queryParams.append('Properties|TotalCost__c', String(propertiesTotalCostC));
    }
    if (propertiesUnitPriceC !== undefined) {
      queryParams.append('Properties|UnitPrice__c', String(propertiesUnitPriceC));
    }
    if (propertiesUnitCostC !== undefined) {
      queryParams.append('Properties|UnitCost__c', String(propertiesUnitCostC));
    }
    if (propertiesIsDiscountItemC !== undefined) {
      queryParams.append('Properties|IsDiscountItem__c', String(propertiesIsDiscountItemC));
    }
    if (propertiesProductC !== undefined) {
      queryParams.append('Properties|Product__c', String(propertiesProductC));
    }
    if (propertiesCost2C !== undefined) {
      queryParams.append('Properties|Cost2__c', String(propertiesCost2C));
    }
    if (propertiesPrice1C !== undefined) {
      queryParams.append('Properties|Price1__c', String(propertiesPrice1C));
    }
    if (propertiesPrice2C !== undefined) {
      queryParams.append('Properties|Price2__c', String(propertiesPrice2C));
    }
    if (propertiesIndexC !== undefined) {
      queryParams.append('Properties|Index__c', String(propertiesIndexC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterSectionLine(request?: FilterSectionLineRequest | null, options?: { headers?: Record<string, string> }): Promise<SectionLine[]> {
    const path = '/app/api/Object/salesforce.INET_SectionLineItem__c/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterSectionLineRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => SectionLineSerializer.fromObject(item));
  }

  async updateSectionLine(objectId: string, request?: UpdateSectionLineRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.INET_SectionLineItem__c({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateSectionLineRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentSectionLine(request?: FilterSectionLineRequest | null, options?: { headers?: Record<string, string> }): Promise<SectionLine[]> {
    const path = '/app/api/Object/salesforce.INET_SectionLineItem__c/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterSectionLineRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => SectionLineSerializer.fromObject(item));
  }

  async dataViewSectionLine(request?: FilterSectionLineRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewSectionLineResponse> {
    const path = '/app/api/Object/salesforce.INET_SectionLineItem__c/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterSectionLineRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewSectionLineResponseSerializer.fromObject(data);
  }

  async getFormForSection(formName: string, objectId: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesParentOptionC?: string | null, propertiesAreaC?: number | null, propertiesNameC?: string | null, propertiesPerimeterC?: number | null, propertiesTotalBeforeTaxC?: number | null, propertiesTotalCostC?: number | null, propertiesTotalPriceC?: number | null, propertiesTotalTaxC?: number | null, propertiesWasteFactorC?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_Section__c({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesParentOptionC !== undefined) {
      queryParams.append('Properties|ParentOption__c', String(propertiesParentOptionC));
    }
    if (propertiesAreaC !== undefined) {
      queryParams.append('Properties|Area__c', String(propertiesAreaC));
    }
    if (propertiesNameC !== undefined) {
      queryParams.append('Properties|Name__c', String(propertiesNameC));
    }
    if (propertiesPerimeterC !== undefined) {
      queryParams.append('Properties|Perimeter__c', String(propertiesPerimeterC));
    }
    if (propertiesTotalBeforeTaxC !== undefined) {
      queryParams.append('Properties|TotalBeforeTax__c', String(propertiesTotalBeforeTaxC));
    }
    if (propertiesTotalCostC !== undefined) {
      queryParams.append('Properties|TotalCost__c', String(propertiesTotalCostC));
    }
    if (propertiesTotalPriceC !== undefined) {
      queryParams.append('Properties|TotalPrice__c', String(propertiesTotalPriceC));
    }
    if (propertiesTotalTaxC !== undefined) {
      queryParams.append('Properties|TotalTax__c', String(propertiesTotalTaxC));
    }
    if (propertiesWasteFactorC !== undefined) {
      queryParams.append('Properties|WasteFactor__c', String(propertiesWasteFactorC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeSection(formName: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesParentOptionC?: string | null, propertiesAreaC?: number | null, propertiesNameC?: string | null, propertiesPerimeterC?: number | null, propertiesTotalBeforeTaxC?: number | null, propertiesTotalCostC?: number | null, propertiesTotalPriceC?: number | null, propertiesTotalTaxC?: number | null, propertiesWasteFactorC?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.INET_Section__c/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesParentOptionC !== undefined) {
      queryParams.append('Properties|ParentOption__c', String(propertiesParentOptionC));
    }
    if (propertiesAreaC !== undefined) {
      queryParams.append('Properties|Area__c', String(propertiesAreaC));
    }
    if (propertiesNameC !== undefined) {
      queryParams.append('Properties|Name__c', String(propertiesNameC));
    }
    if (propertiesPerimeterC !== undefined) {
      queryParams.append('Properties|Perimeter__c', String(propertiesPerimeterC));
    }
    if (propertiesTotalBeforeTaxC !== undefined) {
      queryParams.append('Properties|TotalBeforeTax__c', String(propertiesTotalBeforeTaxC));
    }
    if (propertiesTotalCostC !== undefined) {
      queryParams.append('Properties|TotalCost__c', String(propertiesTotalCostC));
    }
    if (propertiesTotalPriceC !== undefined) {
      queryParams.append('Properties|TotalPrice__c', String(propertiesTotalPriceC));
    }
    if (propertiesTotalTaxC !== undefined) {
      queryParams.append('Properties|TotalTax__c', String(propertiesTotalTaxC));
    }
    if (propertiesWasteFactorC !== undefined) {
      queryParams.append('Properties|WasteFactor__c', String(propertiesWasteFactorC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterSection(request?: FilterSectionRequest | null, options?: { headers?: Record<string, string> }): Promise<Section[]> {
    const path = '/app/api/Object/salesforce.INET_Section__c/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterSectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => SectionSerializer.fromObject(item));
  }

  async updateSection(objectId: string, request?: UpdateSectionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.INET_Section__c({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateSectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentSection(request?: FilterSectionRequest | null, options?: { headers?: Record<string, string> }): Promise<Section[]> {
    const path = '/app/api/Object/salesforce.INET_Section__c/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterSectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => SectionSerializer.fromObject(item));
  }

  async dataViewSection(request?: FilterSectionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewSectionResponse> {
    const path = '/app/api/Object/salesforce.INET_Section__c/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterSectionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewSectionResponseSerializer.fromObject(data);
  }

  async getFormForLead2(formName: string, objectId: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesStreet?: string | null, propertiesPhone?: string | null, propertiesEmail?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.Lead({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesStreet !== undefined) {
      queryParams.append('Properties|Street', String(propertiesStreet));
    }
    if (propertiesPhone !== undefined) {
      queryParams.append('Properties|Phone', String(propertiesPhone));
    }
    if (propertiesEmail !== undefined) {
      queryParams.append('Properties|Email', String(propertiesEmail));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeLead2(formName: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesStreet?: string | null, propertiesPhone?: string | null, propertiesEmail?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.Lead/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesStreet !== undefined) {
      queryParams.append('Properties|Street', String(propertiesStreet));
    }
    if (propertiesPhone !== undefined) {
      queryParams.append('Properties|Phone', String(propertiesPhone));
    }
    if (propertiesEmail !== undefined) {
      queryParams.append('Properties|Email', String(propertiesEmail));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterLead2(request?: FilterLead2Request | null, options?: { headers?: Record<string, string> }): Promise<Lead2[]> {
    const path = '/app/api/Object/salesforce.Lead/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLead2RequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => Lead2Serializer.fromObject(item));
  }

  async updateLead2(objectId: string, request?: UpdateLead2Request | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/salesforce/api/Object/salesforce.Lead({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateLead2RequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentLead2(request?: FilterLead2Request | null, options?: { headers?: Record<string, string> }): Promise<Lead2[]> {
    const path = '/app/api/Object/salesforce.Lead/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLead2RequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => Lead2Serializer.fromObject(item));
  }

  async dataViewLead2(request?: FilterLead2Request | null, options?: { headers?: Record<string, string> }): Promise<DataviewLead2Response> {
    const path = '/app/api/Object/salesforce.Lead/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLead2RequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewLead2ResponseSerializer.fromObject(data);
  }

  async getFormForProductItem(formName: string, objectId: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesName?: string | null, propertiesProductCode?: string | null, propertiesIsActive?: boolean | null, propertiesQuantityUnitOfMeasure?: string | null, propertiesIsDeleted?: boolean | null, propertiesStockKeepingUnit?: string | null, propertiesInetIsLaborC?: boolean | null, propertiesInetNotesC?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.Product2({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesName !== undefined) {
      queryParams.append('Properties|Name', String(propertiesName));
    }
    if (propertiesProductCode !== undefined) {
      queryParams.append('Properties|ProductCode', String(propertiesProductCode));
    }
    if (propertiesIsActive !== undefined) {
      queryParams.append('Properties|IsActive', String(propertiesIsActive));
    }
    if (propertiesQuantityUnitOfMeasure !== undefined) {
      queryParams.append('Properties|QuantityUnitOfMeasure', String(propertiesQuantityUnitOfMeasure));
    }
    if (propertiesIsDeleted !== undefined) {
      queryParams.append('Properties|IsDeleted', String(propertiesIsDeleted));
    }
    if (propertiesStockKeepingUnit !== undefined) {
      queryParams.append('Properties|StockKeepingUnit', String(propertiesStockKeepingUnit));
    }
    if (propertiesInetIsLaborC !== undefined) {
      queryParams.append('Properties|INET_IsLabor__c', String(propertiesInetIsLaborC));
    }
    if (propertiesInetNotesC !== undefined) {
      queryParams.append('Properties|INET_Notes__c', String(propertiesInetNotesC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeProductItem(formName: string, externalId?: string | null, isActive?: boolean | null, flowId?: string | null, objectStatusId?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesName?: string | null, propertiesProductCode?: string | null, propertiesIsActive?: boolean | null, propertiesQuantityUnitOfMeasure?: string | null, propertiesIsDeleted?: boolean | null, propertiesStockKeepingUnit?: string | null, propertiesInetIsLaborC?: boolean | null, propertiesInetNotesC?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.Product2/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesName !== undefined) {
      queryParams.append('Properties|Name', String(propertiesName));
    }
    if (propertiesProductCode !== undefined) {
      queryParams.append('Properties|ProductCode', String(propertiesProductCode));
    }
    if (propertiesIsActive !== undefined) {
      queryParams.append('Properties|IsActive', String(propertiesIsActive));
    }
    if (propertiesQuantityUnitOfMeasure !== undefined) {
      queryParams.append('Properties|QuantityUnitOfMeasure', String(propertiesQuantityUnitOfMeasure));
    }
    if (propertiesIsDeleted !== undefined) {
      queryParams.append('Properties|IsDeleted', String(propertiesIsDeleted));
    }
    if (propertiesStockKeepingUnit !== undefined) {
      queryParams.append('Properties|StockKeepingUnit', String(propertiesStockKeepingUnit));
    }
    if (propertiesInetIsLaborC !== undefined) {
      queryParams.append('Properties|INET_IsLabor__c', String(propertiesInetIsLaborC));
    }
    if (propertiesInetNotesC !== undefined) {
      queryParams.append('Properties|INET_Notes__c', String(propertiesInetNotesC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterProductItem(request?: FilterProductItemRequest | null, options?: { headers?: Record<string, string> }): Promise<ProductItem[]> {
    const path = '/app/api/Object/salesforce.Product2/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProductItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProductItemSerializer.fromObject(item));
  }

  async recentProductItem(request?: FilterProductItemRequest | null, options?: { headers?: Record<string, string> }): Promise<ProductItem[]> {
    const path = '/app/api/Object/salesforce.Product2/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProductItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProductItemSerializer.fromObject(item));
  }

  async dataViewProductItem(request?: FilterProductItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewProductItemResponse> {
    const path = '/app/api/Object/salesforce.Product2/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProductItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewProductItemResponseSerializer.fromObject(data);
  }

  async getProjectScheduleAppointmentForm(objectId: string, start?: string | null, duration?: string | null, name?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(55d2b278-00bc-468a-bb46-0a7f0f6fda16)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (start !== undefined) {
      queryParams.append('Start', String(start));
    }
    if (duration !== undefined) {
      queryParams.append('Duration', String(duration));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runProjectScheduleAppointmentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(55d2b278-00bc-468a-bb46-0a7f0f6fda16)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProjectScheduleAppointment(objectId: string, request?: StartProjectScheduleAppointmentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(55d2b278-00bc-468a-bb46-0a7f0f6fda16)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartProjectScheduleAppointmentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getProjectAddNoteForm(objectId: string, name?: string | null, description?: string | null, content?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(f8826618-616a-4d97-b606-2b3291030fe5)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runProjectAddNoteAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(f8826618-616a-4d97-b606-2b3291030fe5)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProjectAddNote(objectId: string, request?: StartProjectAddNoteRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(f8826618-616a-4d97-b606-2b3291030fe5)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartProjectAddNoteRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getProjectAddTaskForm(objectId: string, name?: string | null, description?: string | null, content?: string | null, dueDate?: string | null, dueTime?: any | null, assignUserId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(111306bf-9cfb-4110-8afa-162146db166f)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (content !== undefined) {
      queryParams.append('Content', String(content));
    }
    if (dueDate !== undefined) {
      queryParams.append('DueDate', String(dueDate));
    }
    if (dueTime !== undefined) {
      queryParams.append('DueTime', String(dueTime));
    }
    if (assignUserId !== undefined) {
      queryParams.append('AssignUserId', String(assignUserId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runProjectAddTaskAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(111306bf-9cfb-4110-8afa-162146db166f)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProjectAddTask(objectId: string, request?: StartProjectAddTaskRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(111306bf-9cfb-4110-8afa-162146db166f)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartProjectAddTaskRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getProjectGenerateContentForm(objectId: string, assistantId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(ef7936a9-27f5-4532-b950-de29b8866301)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (assistantId !== undefined) {
      queryParams.append('AssistantId', String(assistantId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runProjectGenerateContentAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(ef7936a9-27f5-4532-b950-de29b8866301)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProjectGenerateContent(objectId: string, request?: StartProjectGenerateContentRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(ef7936a9-27f5-4532-b950-de29b8866301)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartProjectGenerateContentRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async runProjectAskSyntheaAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(1e53920b-1392-484c-ac15-eeeff960bd63)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProjectAskSynthea(objectId: string, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(1e53920b-1392-484c-ac15-eeeff960bd63)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getProjectAddFpRoomForm(objectId: string, leadId?: string | null, workOrderId?: string | null, name?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(5d6ffeaa-3d34-49d5-be4a-2856997f2d0b)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (leadId !== undefined) {
      queryParams.append('LeadId', String(leadId));
    }
    if (workOrderId !== undefined) {
      queryParams.append('WorkOrderId', String(workOrderId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runProjectAddFpRoomAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(5d6ffeaa-3d34-49d5-be4a-2856997f2d0b)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProjectAddFpRoom(objectId: string, request?: StartProjectAddFpRoomRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(5d6ffeaa-3d34-49d5-be4a-2856997f2d0b)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartProjectAddFpRoomRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getProjectAssignContactForm(objectId: string, contactId?: string | null, role?: string | null, parentObjectType?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(3199f813-6a0a-40cb-b866-8c1f4110df5c)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (contactId !== undefined) {
      queryParams.append('ContactId', String(contactId));
    }
    if (role !== undefined) {
      queryParams.append('Role', String(role));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('ParentObjectType', String(parentObjectType));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runProjectAssignContactAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(3199f813-6a0a-40cb-b866-8c1f4110df5c)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startProjectAssignContact(objectId: string, request?: StartProjectAssignContactRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/UserAction(3199f813-6a0a-40cb-b866-8c1f4110df5c)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartProjectAssignContactRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForProject(formName: string, objectId: string, externalId?: string | null, flowId?: string | null, objectStatusId?: string | null, propertiesAccountId?: string | null, description?: string | null, name?: string | null, tags?: string[] | null, roomNames?: string[] | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesWorkOrderNumber?: string | null, propertiesCreatedDate?: string | null, propertiesStreet?: string | null, propertiesCity?: string | null, propertiesState?: string | null, propertiesPostalCode?: string | null, propertiesDescription?: string | null, propertiesStatus?: string | null, propertiesInetCustomerNotesC?: string | null, propertiesInetFloorPlanC?: string | null, propertiesInetInspectionNotesC?: string | null, propertiesInetInspectionVideoC?: string | null, propertiesInetLeadC?: string | null, propertiesInetNameC?: string | null, propertiesInetNotesC?: string | null, propertiesInetDebriefNotesC?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (propertiesAccountId !== undefined) {
      queryParams.append('Properties|AccountId', String(propertiesAccountId));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (roomNames !== undefined) {
      queryParams.append('RoomNames', String(roomNames));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesWorkOrderNumber !== undefined) {
      queryParams.append('Properties|WorkOrderNumber', String(propertiesWorkOrderNumber));
    }
    if (propertiesCreatedDate !== undefined) {
      queryParams.append('Properties|CreatedDate', String(propertiesCreatedDate));
    }
    if (propertiesStreet !== undefined) {
      queryParams.append('Properties|Street', String(propertiesStreet));
    }
    if (propertiesCity !== undefined) {
      queryParams.append('Properties|City', String(propertiesCity));
    }
    if (propertiesState !== undefined) {
      queryParams.append('Properties|State', String(propertiesState));
    }
    if (propertiesPostalCode !== undefined) {
      queryParams.append('Properties|PostalCode', String(propertiesPostalCode));
    }
    if (propertiesDescription !== undefined) {
      queryParams.append('Properties|Description', String(propertiesDescription));
    }
    if (propertiesStatus !== undefined) {
      queryParams.append('Properties|Status', String(propertiesStatus));
    }
    if (propertiesInetCustomerNotesC !== undefined) {
      queryParams.append('Properties|INET_CustomerNotes__c', String(propertiesInetCustomerNotesC));
    }
    if (propertiesInetFloorPlanC !== undefined) {
      queryParams.append('Properties|INET_FloorPlan__c', String(propertiesInetFloorPlanC));
    }
    if (propertiesInetInspectionNotesC !== undefined) {
      queryParams.append('Properties|INET_InspectionNotes__c', String(propertiesInetInspectionNotesC));
    }
    if (propertiesInetInspectionVideoC !== undefined) {
      queryParams.append('Properties|INET_InspectionVideo__c', String(propertiesInetInspectionVideoC));
    }
    if (propertiesInetLeadC !== undefined) {
      queryParams.append('Properties|INET_Lead__c', String(propertiesInetLeadC));
    }
    if (propertiesInetNameC !== undefined) {
      queryParams.append('Properties|INET_Name__c', String(propertiesInetNameC));
    }
    if (propertiesInetNotesC !== undefined) {
      queryParams.append('Properties|INET_Notes__c', String(propertiesInetNotesC));
    }
    if (propertiesInetDebriefNotesC !== undefined) {
      queryParams.append('Properties|INET_DebriefNotes__c', String(propertiesInetDebriefNotesC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeProject(formName: string, externalId?: string | null, flowId?: string | null, objectStatusId?: string | null, propertiesAccountId?: string | null, description?: string | null, name?: string | null, tags?: string[] | null, roomNames?: string[] | null, entityId?: string | null, id?: string | null, createdOn?: string | null, propertiesId?: string | null, propertiesWorkOrderNumber?: string | null, propertiesCreatedDate?: string | null, propertiesStreet?: string | null, propertiesCity?: string | null, propertiesState?: string | null, propertiesPostalCode?: string | null, propertiesDescription?: string | null, propertiesStatus?: string | null, propertiesInetCustomerNotesC?: string | null, propertiesInetFloorPlanC?: string | null, propertiesInetInspectionNotesC?: string | null, propertiesInetInspectionVideoC?: string | null, propertiesInetLeadC?: string | null, propertiesInetNameC?: string | null, propertiesInetNotesC?: string | null, propertiesInetDebriefNotesC?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/salesforce.WorkOrder/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (propertiesAccountId !== undefined) {
      queryParams.append('Properties|AccountId', String(propertiesAccountId));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (roomNames !== undefined) {
      queryParams.append('RoomNames', String(roomNames));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (propertiesId !== undefined) {
      queryParams.append('Properties|Id', String(propertiesId));
    }
    if (propertiesWorkOrderNumber !== undefined) {
      queryParams.append('Properties|WorkOrderNumber', String(propertiesWorkOrderNumber));
    }
    if (propertiesCreatedDate !== undefined) {
      queryParams.append('Properties|CreatedDate', String(propertiesCreatedDate));
    }
    if (propertiesStreet !== undefined) {
      queryParams.append('Properties|Street', String(propertiesStreet));
    }
    if (propertiesCity !== undefined) {
      queryParams.append('Properties|City', String(propertiesCity));
    }
    if (propertiesState !== undefined) {
      queryParams.append('Properties|State', String(propertiesState));
    }
    if (propertiesPostalCode !== undefined) {
      queryParams.append('Properties|PostalCode', String(propertiesPostalCode));
    }
    if (propertiesDescription !== undefined) {
      queryParams.append('Properties|Description', String(propertiesDescription));
    }
    if (propertiesStatus !== undefined) {
      queryParams.append('Properties|Status', String(propertiesStatus));
    }
    if (propertiesInetCustomerNotesC !== undefined) {
      queryParams.append('Properties|INET_CustomerNotes__c', String(propertiesInetCustomerNotesC));
    }
    if (propertiesInetFloorPlanC !== undefined) {
      queryParams.append('Properties|INET_FloorPlan__c', String(propertiesInetFloorPlanC));
    }
    if (propertiesInetInspectionNotesC !== undefined) {
      queryParams.append('Properties|INET_InspectionNotes__c', String(propertiesInetInspectionNotesC));
    }
    if (propertiesInetInspectionVideoC !== undefined) {
      queryParams.append('Properties|INET_InspectionVideo__c', String(propertiesInetInspectionVideoC));
    }
    if (propertiesInetLeadC !== undefined) {
      queryParams.append('Properties|INET_Lead__c', String(propertiesInetLeadC));
    }
    if (propertiesInetNameC !== undefined) {
      queryParams.append('Properties|INET_Name__c', String(propertiesInetNameC));
    }
    if (propertiesInetNotesC !== undefined) {
      queryParams.append('Properties|INET_Notes__c', String(propertiesInetNotesC));
    }
    if (propertiesInetDebriefNotesC !== undefined) {
      queryParams.append('Properties|INET_DebriefNotes__c', String(propertiesInetDebriefNotesC));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterProject(request?: FilterProjectRequest | null, options?: { headers?: Record<string, string> }): Promise<Project[]> {
    const path = '/app/api/Object/salesforce.WorkOrder/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProjectRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProjectSerializer.fromObject(item));
  }

  async updateProject(objectId: string, request?: UpdateProjectRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/salesforce.WorkOrder({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateProjectRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentProject(request?: FilterProjectRequest | null, options?: { headers?: Record<string, string> }): Promise<Project[]> {
    const path = '/app/api/Object/salesforce.WorkOrder/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProjectRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ProjectSerializer.fromObject(item));
  }

  async dataViewProject(request?: FilterProjectRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewProjectResponse> {
    const path = '/app/api/Object/salesforce.WorkOrder/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterProjectRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewProjectResponseSerializer.fromObject(data);
  }

}
